var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"}),_c('div',{staticClass:"col-12"},[_c('h1',[_vm._v(_vm._s(_vm.zona.sector))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }